<div class="topHead">
    <h2>Content Authoring</h2>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">
    <div class="pageTitleBox">
        <h2>Content Authoring</h2> 
    </div>
    <div class="adminTabWrap">
        <div class="filterWrap">
            <div class="searchWrap mr-5">
                <input type="text" placeholder="Search by Capsule Name" (keyup)="search($event)" />
            </div>
            <a href="javascript:void(0);" [routerLink]="['/authoring_create']" class="btn btn-primary btn-sm">+ Create
                New Content Capsule</a>
        </div>
        <!--  [selectedIndex]="{{tabIndex}}" -->
        <mat-tab-group animationDuration="0ms" [selectedIndex]="tabIndex" (selectedTabChange)="onSelectChange($event)">
            <mat-tab label="Active" (click)="getContentAuthList('',1)">
                <div class="tableWrap">
                    <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                        <thead>
                            <tr>
                                <th>
                                    <div mat-sort-header="capsule_name"><b></b> Content Capsule Name</div>
                                </th>
                                <th>Capsule Type</th>
                                <th>Created By</th>
                                <th>Active Courses<br />
                                    (Assigned To)</th>
                                <th>Deactivated<br />Courses<br />(Assigned To)</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let values of contentAuthData; let i = index">
                                <td>
                                    <div class="userTdWrap">
                                        <!-- [routerLink]="['/courses_details']" -->
                                        <a href="javascript:void(0);" class="btn-link"
                                            [routerLink]="['/authoring_viewContent']"
                                            [queryParams]="{id:values.content_capsule_id}">{{values.capsule_name}}</a>
                                        <b class="d-block">Modified on {{values.modified_dttm}}</b>
                                    </div>
                                </td>
                                <td>
                                    <ul class="modifyIcons" *ngIf="(values.contentCapsuleMedia)">
                                        <li *ngIf="(values.assessment_id)"><a><img
                                                    src="assets/images/icons/frame.svg"></a></li>
                                        <li *ngIf="(getMediaType(values.contentCapsuleMedia,'1')==true)"><a>
                                            <img src="assets/images/icons/text.svg"></a>
                                        </li>
                                        <li *ngIf="(getMediaType(values.contentCapsuleMedia,'2')==true)"><a>
                                            <img src="assets/images/icons/insert-picture.svg"></a></li>
                                        <li *ngIf="(getMediaType(values.contentCapsuleMedia,'3')==true)"><a>
                                            <img src="assets/images/icons/video-camera.svg"></a></li>
                                    </ul>
                                </td>
                                <td>{{values.created_by}}</td>

                                <td><a href="javascript:void(0);" class="btn-link">{{values.active_courses}}</a></td>
                                <td><a href="javascript:void(0);" class="btn-link">{{values.deactive_courses}}</a></td>
                                <td>
                                    <ul class="userActionBtn">
                                        <li><a href="javascript:void(0);" class="btn-link"
                                                [routerLink]="['/authoring_create']"
                                                [queryParams]="{id:values.content_capsule_id}">EDIT</a></li>
                                        <li class="w-auto"><a href="javascript:void(0);" class="btn-link" (click)="open(duplicate,values.content_capsule_id,'Active')">DUPLICATE</a></li>
                                        <li><a href="javascript:void(0);" class="btn-link second-link"
                                                (click)="open(deactivate,values.content_capsule_id,'Active')">DEACTIVATE</a>
                                        </li>
                                        <li><a href="javascript:void(0);" class="btn-link second-link"
                                            (click)="open(delete,values.content_capsule_id,'Active')">DELETE</a></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr class="selectTr" *ngIf="(contentAuthData && contentAuthData.length == 0)">
                                <td [attr.colspan]="5">No Record found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </mat-tab>

            <mat-tab label="Deactivated" (click)="getContentAuthList('',0)">
                <div class="tableWrap">
                    <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                        <thead>
                            <tr>
                                <th>
                                    <div mat-sort-header="capsule_name"><b></b> Content Capsule Name</div>
                                </th>
                                <th>Capsule Type</th>
                                <th>Created By</th>
                                <th>Active Courses<br />
                                    (Assigned To)</th>
                                <th>Deactivated<br />Courses<br />(Assigned To)</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let values of contentAuthData; let i = index">
                                <td >
                                    <div class="userTdWrap">
                                        <a href="javascript:void(0);" class="btn-link"
                                            [routerLink]="['/authoring_viewContent']"
                                            [queryParams]="{id:values.content_capsule_id,tab:1}">{{values.capsule_name}} </a>
                                        <b class="d-block">Modified on {{values.modified_dttm}}</b>
                                    </div>
                                </td>
                                <td>
                                    <ul class="modifyIcons" *ngIf="(values.contentCapsuleMedia)">
                                        <li *ngIf="(values.assessment_id)"><a ><img
                                                    src="assets/images/icons/frame.svg"></a></li>
                                        <li *ngIf="(getMediaType(values.contentCapsuleMedia,'1')==true)"><a
                                                ><img src="assets/images/icons/text.svg"></a>
                                        </li>
                                        <li *ngIf="(getMediaType(values.contentCapsuleMedia,'2')==true)"><a
                                                ><img
                                                    src="assets/images/icons/insert-picture.svg"></a></li>
                                        <li *ngIf="(getMediaType(values.contentCapsuleMedia,'3')==true)"><a
                                                ><img
                                                    src="assets/images/icons/video-camera.svg"></a></li>
                                    </ul>
                                </td>
                                <td>{{values.created_by}}</td>

                                <td><a href="javascript:void(0);" class="btn-link">{{values.active_courses}}</a></td>
                                <td><a href="javascript:void(0);" class="btn-link">{{values.deactive_courses}}</a></td>
                                <td>
                                    <ul class="userActionBtn">
                                        <li class="w-auto"><a href="javascript:void(0);" class="btn-link" (click)="open(duplicate,values.content_capsule_id,'Deactivated')">DUPLICATE</a></li>
                                        <li><a href="javascript:void(0);"
                                                (click)="open(content,values.content_capsule_id,'Deactivated')"
                                                class="btn-link-green">ACTIVATE</a></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr class="selectTr" *ngIf="(contentAuthData && contentAuthData.length == 0)">
                                <td [attr.colspan]="6">No Record found.</td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </mat-tab>
            <mat-tab label="DRAFT" (click)="getContentAuthList('',2)">
                <div class="tableWrap">
                    <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                        <thead>
                            <tr>
                                <th>
                                    <div mat-sort-header="capsule_name" ><b></b>Content Capsule Name</div>
                                </th>
                                <th>Created By</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let values of contentAuthData; let i = index">
                                <td >
                                    <div class="userTdWrap">
                                        <a href="javascript:void(0);" class="btn-link"
                                            [routerLink]="['/authoring_create']"
                                            [queryParams]="{id:values.content_capsule_id,tab:2}">{{values.capsule_name}} </a>
                                        <b class="d-block">Started on {{values.created_dttm}}</b>
                                    </div>
                                </td>

                                <td>{{values.created_by}}</td>

                                <td><a href="javascript:void(0);" [routerLink]="['/authoring_view']"
                                    [queryParams]="{id:values.content_capsule_id,tab:2}"
                                        class="btn-link">PREVIEW</a></td>
                                <td><a href="javascript:void(0);" class="btn-link" (click)="open(duplicate,values.content_capsule_id,'DRAFT')">DUPLICATE</a>
                                </td>
                                <td><a href="javascript:void(0);" class="btn-link " (click)="open(publish,values.content_capsule_id,'DRAFT')" *ngIf="values.contentCapsuleMedia.length !=0">PUBLISH</a></td>
                                <td><a href="javascript:void(0);" class="btn-link second-link"
                                        (click)="open(delete,values.content_capsule_id,'DRAFT')">DELETE</a></td>
                            </tr>
                            <tr class="selectTr" *ngIf="(contentAuthData && contentAuthData.length == 0)">
                                <td [attr.colspan]="4">No Record found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate content capsule</h6>
                <p class="size18">Are you sure you want to activate this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsActiveVal(content_capsule_ids,1)">Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate content capsule</h6>
                <p class="size18">Are you sure you want to deactivate this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(content_capsule_ids,0)">Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #delete let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Delete content capsule</h6>
                <p class="size18">Are you sure you want to Delete this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="deleteCapsule(content_capsule_ids)">Yes, Delete</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #publish let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Publish content capsule</h6>
                <p class="size18">Are you sure you want to Publish this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="publishCapsule(content_capsule_ids)">Yes, publish</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate content capsule</h6>
                <p class="size18">Are you sure you want to Duplicate this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="duplicateCapsule(content_capsule_ids,tabName)">Yes, Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>

<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>